module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av333-d292aa871ec485e35e427b67a3990be4.jpg";